import type { EntityOption } from '@/hooks/useEntityOptions';
import { Skeleton } from '@/components/ui/skeleton';

interface EntityCellProps {
  value: unknown;
  options?: EntityOption[];
  isLoading?: boolean;
}

export function EntityCell({ value, options, isLoading }: EntityCellProps) {
  if (value == null || value === '') return null;

  const strValue = String(value);

  // Handle _create: sentinel — show the pending name with a visual indicator
  if (strValue.startsWith('_create:')) {
    const name = strValue.slice(8);
    return <span className="italic text-primary">{name}</span>;
  }

  // Show skeleton while entity options are loading to avoid displaying raw UUIDs
  const option = options?.find(o => o.value === strValue);
  if (!option && isLoading) {
    return <Skeleton className="h-4 w-24" />;
  }

  return <span>{option?.label ?? strValue}</span>;
}
